import { createRouter, createWebHashHistory } from 'vue-router'
const routes = [
  {
    path: '/',
    name: 'login',
    component: require("../views/login.vue").default
  }
]

const router = createRouter({
  history: createWebHashHistory(), // hash模式 #号后面跟路由地址
  routes
})

export default router
